import React, { useRef, useState } from "react";
import Card from "components/Card";
import styles from "./Graph.module.css";
import { DropDown } from "assets";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    ResponsiveContainer,
} from "recharts";
import { useAppSelector } from "store/hooks";
import { formatNumberWithCommas } from "utils/functions";

const _ = require("lodash");

export default function Graph({ BAR_WIDTH }: { BAR_WIDTH: number }) {
    const graphDetails = useAppSelector((state) => state.user.graphDetails) || [];
    const chartRef = useRef<HTMLDivElement>(null); // Reference for the chart container
    const [tooltip, setTooltip] = useState<{
        x: number;
        y: number;
        value: number;
    } | null>(null);
    const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

    const handleMouseEnter = (data: any, index: number) => {
        const { x, totalFeeSum, height } = data;

        if (x !== undefined) {
            setTooltip({
                x: x + (BAR_WIDTH / 2),
                y: height,
                value: totalFeeSum,
            });
        }
        setHoveredIndex(index);
    };

    const handleMouseLeave = () => {
        setTooltip(null);
        setHoveredIndex(null);
    };

    return (
        <div ref={chartRef}
            className="w-100" style={{ border: '1px solid', borderColor: 'transparent', height: '90%', minHeight: '90%', position: "relative" }}>
            {tooltip && (
                <div
                    style={{
                        position: "absolute",
                        bottom: tooltip.y + 30,
                        left: tooltip.x - 25,
                        backgroundColor: "#fff",
                        border: "1px solid #C3C3C3",
                        boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
                        borderRadius: "4px",
                        textAlign: "center",
                        padding: "5px",
                        zIndex: 10,
                    }}
                >
                    ₪{formatNumberWithCommas(String(tooltip.value))}
                    <div className={styles.arrow}
                    ></div>
                </div>
            )}
            <ResponsiveContainer style={{ marginTop: 20 }} width={'100%'} height={'100%'}>
                <BarChart data={graphDetails}>
                    <CartesianGrid
                        strokeDasharray="4 4"
                        stroke="#272425"
                        horizontal
                        vertical={false}
                    />
                    <XAxis
                        dataKey="month"
                        axisLine={false}
                        tickCount={12}
                        padding={{ left: 20, right: 0 }}
                        tick={{
                            fontFamily: "Assistant",
                            fontSize: "10px",
                            fontWeight: 600,
                            textAnchor: "middle",
                            dy: 5,
                        }}
                    />
                    <YAxis
                        axisLine={false}
                        tickMargin={0}
                        tickCount={10}
                        interval={0}
                        tick={{
                            fontFamily: "Assistant",
                            fontSize: "10px",
                            fontWeight: 600,
                            textAnchor: "start",
                        }}
                        tickFormatter={(value) => value.toLocaleString("en-US")}
                    />
                    <Bar
                        dataKey="totalFeeSum"
                        fill="#31718A"
                        onMouseEnter={(data, index) => handleMouseEnter(data, index)}
                        onMouseLeave={handleMouseLeave}
                        shape={(props: any) => {
                            const { x, y, width, height, index } = props;
                            const fillColor =
                                index === hoveredIndex ? "#00DDB4" : "#31718A";
                            return (
                                <rect
                                    x={x}
                                    y={y}
                                    width={BAR_WIDTH}
                                    height={height}
                                    fill={fillColor}
                                />
                            );
                        }}
                    />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}
